<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'plugins.installationvoltage.header' | translate }} :</span>
        </h2>
      </div>
      <div class="ir-content--modal th-content th-content-customer">
        <div formArrayName="voltages" *ngFor="let item of formData.controls; let i = index">
          <table class="ir-modal-table">
            <tr>
              <td></td>
              <td class="th-plugin-line--remove th-plugin-line--remove-customer" colspan="2" align="right">
                <i class="material-icons" (click)="openVoltageDeleteConfirm(i)">remove_circle</i>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span style="margin-left: 10px">{{ 'plugins.installationvoltage.datetime' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" style="width: 50%" [formGroupName]="i">
                <div class="ir-form-group">
                  <input name="dateTime" type="datetime-local" formControlName="dateTime" class="ir-form-set" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span style="margin-left: 10px">{{ 'plugins.installationvoltage.L1L2' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" style="width: 50%" [formGroupName]="i">
                <input name="L1L2" class="ir-form-set" type="number" formControlName="L1L2" />
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span style="margin-left: 10px">{{ 'plugins.installationvoltage.L1L3' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" style="width: 50%" [formGroupName]="i">
                <input name="L1L3" class="ir-form-set" type="number" formControlName="L1L3" />
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span style="margin-left: 10px">{{ 'plugins.installationvoltage.L2L3' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" style="width: 50%" [formGroupName]="i">
                <input name="L2L3" class="ir-form-set" type="number" formControlName="L2L3" />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #voltageDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>voltage record</strong>?'"
  [danger]="true"
></confirm>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
